import { render, staticRenderFns } from "./Loads.vue?vue&type=template&id=6b83e8af&scoped=true"
import script from "./Loads.vue?vue&type=script&lang=ts"
export * from "./Loads.vue?vue&type=script&lang=ts"
import style0 from "./Loads.vue?vue&type=style&index=0&id=6b83e8af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83e8af",
  null
  
)

export default component.exports